module.exports = __webpack_public_path__ + "static/media/ava_chatbot.2413ba15.svg";